export const PIN_UNLOCKED_STORAGE_KEY = "pinUnlocked";

export const PIN_PRESENCE_LOCK_NAME = "pin-unlocked-presence";

let requested = false;
let release: (() => void) | null = null;

export const holdUnlockPresence = (): void => {
  if (requested || !navigator?.locks) return;

  requested = true;

  navigator.locks
    .request(
      PIN_PRESENCE_LOCK_NAME,
      { mode: "shared" },
      () =>
        new Promise<void>((resolve) => {
          release = () => {
            release = null;
            resolve();
          };
        })
    )
    .catch(() => {
      requested = false;
    });
};

export const releaseUnlockPresence = (): void => {
  requested = false;
  if (release) release();
};

export const isAnyTabUnlocked = async (): Promise<boolean> => {
  if (!navigator?.locks?.query) return false;

  try {
    const { held } = await navigator.locks.query();
    return !!held?.some((lock) => lock.name === PIN_PRESENCE_LOCK_NAME);
  } catch {
    return false;
  }
};
